
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import notifications from "@/lib/notifications";
import { PalletListFilters } from "@/models/api/barcodeSystem/inventory/pallets";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import Papa from "papaparse";

const inventoryModuleState = getModule(InventoryModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class PalletFilters extends Vue {
  localFilters: PalletListFilters = null;

  get filters() {
    return inventoryModuleState.palletFilters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    inventoryModuleState.setPalletFilters(JSON.parse(JSON.stringify(this.localFilters)));
    inventoryModuleState.setLoading(true);
    try {
      await inventoryModuleState.getPallets({
        pageNumber: 1,
        pageSize: inventoryModuleState.palletPageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Pallets", "Failed to load pallets", ex);
    }

    inventoryModuleState.setLoading(false);
  }

  async exportPalletItems() {
    inventoryModuleState.setLoading(true);
    try {    
      var csvData = [];
      var i = [];
      inventoryModuleState.palletFields.forEach(function (field) {
        if(field.label !== "" && field.hidden === false) {
          i.push(field.label);
        }
      });
      csvData.push(i);
      if(inventoryModuleState.palletPageData.totalItems > inventoryModuleState.palletData.length){
        if(inventoryModuleState.palletPageData.totalItems < 5000) {
          await inventoryModuleState.getPalletsExport({
            pageNumber: 1,
            pageSize: inventoryModuleState.palletPageData.totalItems
          });
        } else {
          await inventoryModuleState.getPalletsExport({
            pageNumber: 1,
            pageSize: 5000
          });
        }
      }
      inventoryModuleState.palletData.forEach(function (item) {
        var i = [];
        inventoryModuleState.palletFields.forEach(function (field) {
          if(field.label !== "" && field.hidden === false) {
              i.push(item[field.key]);
          }
        });
        csvData.push(i);
      });  
      let blob = new Blob([Papa.unparse(csvData)], {
        type: "text/csv;charset=utf-8;"
      });

      let link = document.createElement("a");

      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "PalletItems.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (ex) {
      console.log(ex);
      notifications.error("Downloading Pallet Items", "Failed to export Pallet items", ex);
    }

    inventoryModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
